import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Contentsection(props) {
  return (
    <div className="tekrevol_contentsection p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <div className="example" data-text="ERP Solutions">
              <h2>
                Build Best-In-Class Software With Our Professional ERP
                Developers
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <p>
              From strategy roadmaps to technical solutions and product
              development, our ERP developers help startups to million-dollar
              organizations transform their business operations by smoothly
              integrating ERP solutions with their existing systems.
            </p>
            <p>
              As a leading ERP solutions company, we specialize in developing
              ERP software with a core focus on creating human-centric
              solutions, ensuring a flawless integration of technology that
              aligns with the needs and experiences of users and stakeholders.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Contentsection;
